const page = require('../../../../../components/page/page')
const retailDeletedDt = require('./retailDeleted-dt')
import retailDeletedPage from './retailDeleted-page.html'

let HTMLwasSelected = false

function HTMLselect() {
      document.body.insertAdjacentHTML('beforeend', retailDeletedPage)
      HTMLwasSelected = true
}

export function start(detail) {
      if (!HTMLwasSelected) { HTMLselect() }

      if (detail.act === 'show') {
            page.start(detail)
            retailDeletedDt.start({
                  dest: 'retailDeleted',
                  elem: 'dt',
                  act: 'select',
                  entity: 'retailDeleted',
            })
      }
}
